import type { ComponentPropsWithoutRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import type { LinkProps as RouterLinkProps } from 'react-router-dom'

import styles from './styles/Link.css'
import classNames from 'classnames'

type LinkProps = ComponentPropsWithoutRef<'a'> & {
  to?: RouterLinkProps['to']
  blue?: boolean
  underline?: boolean
  bold?: boolean
}

export function Link({
  className,
  href,
  to,
  children,
  bold,
  blue,
  underline,
  tabIndex = 0,
  onClick,
  ...rest
}: LinkProps) {
  return to ? (
    <RouterLink
      className={classNames(
        className,
        styles.link,
        {
          [styles.blueLink]: blue,
          [styles.underline]: underline,
          [styles.bold]: bold
        },
        className
      )}
      to={to}
      onClick={onClick}
      tabIndex={tabIndex}
      {...rest}
    >
      {children}
    </RouterLink>
  ) : (
    <a
      className={classNames(
        className,
        styles.link,
        {
          [styles.blueLink]: blue,
          [styles.underline]: underline,
          [styles.bold]: bold
        },
        className
      )}
      href={href}
      onClick={onClick}
      tabIndex={tabIndex}
      role='link'
      {...rest}
    >
      {children}
    </a>
  )
}

export default Link
